function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (t, e) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["vue2-collapse"] = e() : t["vue2-collapse"] = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    function e(s) {
      if (n[s]) return n[s].exports;
      var o = n[s] = {
        i: s,
        l: !1,
        exports: {}
      };
      return t[s].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.d = function (t, n, s) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: s
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function () {
        return t["default"];
      } : function () {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "/", e(e.s = 4);
  }([function (t, e, n) {
    "use strict";

    var s = "v-collapse",
        o = {
      prefix: s,
      basename: "collapse",
      togglerClassDefault: s + "-toggler",
      contentClassDefault: s + "-content",
      contentClassEnd: s + "-content-end"
    },
        i = function i(t, e) {
      t.classList.toggle(e.contentClassEnd);
    },
        r = function r(t, e) {
      t.classList.remove(e.contentClassEnd);
    },
        c = function c(t, e) {
      t.classList.add(e.contentClassEnd);
    };

    t.exports = {
      defaults: o,
      toggleElement: i,
      closeElement: r,
      openElement: c
    };
  }, function (t, e) {
    t.exports = function (t, e, n, s, o, i) {
      var r,
          c = t = t || {},
          u = _typeof(t["default"]);

      "object" !== u && "function" !== u || (r = t, c = t["default"]);
      var l = "function" == typeof c ? c.options : c;
      e && (l.render = e.render, l.staticRenderFns = e.staticRenderFns, l._compiled = !0), n && (l.functional = !0), o && (l._scopeId = o);
      var a;

      if (i ? (a = function a(t) {
        t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, t || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__), s && s.call(this, t), t && t._registeredComponents && t._registeredComponents.add(i);
      }, l._ssrRegister = a) : s && (a = s), a) {
        var f = l.functional,
            d = f ? l.render : l.beforeCreate;
        f ? (l._injectStyles = a, l.render = function (t, e) {
          return a.call(e), d(t, e);
        }) : l.beforeCreate = d ? [].concat(d, a) : [a];
      }

      return {
        esModule: r,
        exports: c,
        options: l
      };
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = n(0);
    e["default"] = {
      data: function data() {
        return {
          nodes: {},
          status: !1
        };
      },
      props: ["active"],
      watch: {
        active: function active(t) {
          null != t && (this.status = t);
        },
        status: function status(t, e) {
          if (this.$emit("onStatusChange", {
            vm: this,
            status: t,
            old_status: e
          }), !1 === this.$parent.onlyOneActive) (0, s.toggleElement)(this.nodes.content, this.$options.$vc.settings);else if (!0 === t && !1 === e) {
            var n = this.$parent.$children.filter(function (t) {
              return !0 === t.status;
            });
            n.length > 1 && n.forEach(function (t) {
              t.close(), (0, s.closeElement)(t.nodes.content, this.$options.$vc.settings);
            }.bind(this)), (0, s.openElement)(this.nodes.content, this.$options.$vc.settings), this.open();
          } else !0 === e && !1 === t && ((0, s.closeElement)(this.nodes.content, this.$options.$vc.settings), this.close());
        }
      },
      methods: {
        toggle: function toggle() {
          this.$emit("beforeToggle", this), this.status = !this.status, this.$emit("afterToggle", this);
        },
        close: function close() {
          this.$emit("beforeClose", this), this.status = !1, this.$emit("afterClose", this);
        },
        open: function open() {
          this.$emit("beforeOpen", this), this.status = !0, this.$emit("afterOpen", this);
        }
      },
      mounted: function mounted() {
        var t = this;
        this.nodes.toggle = this.$el.querySelector("." + this.$options.$vc.settings.togglerClassDefault), this.nodes.content = this.$el.querySelector("." + this.$options.$vc.settings.contentClassDefault), this.$emit("afterNodesBinding", {
          vm: this,
          nodes: this.nodes
        }), null !== this.nodes.toggle && this.nodes.toggle.addEventListener("click", function () {
          t.toggle();
        }), null != this.active && (this.status = this.active);
      }
    };
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    n(0);
    e["default"] = {
      data: function data() {
        return {};
      },
      props: {
        onlyOneActive: {
          "default": !1,
          type: Boolean
        }
      },
      computed: {
        elements: function elements() {
          return this.$children;
        },
        elements_count: function elements_count() {
          return this.$children.length;
        },
        active_elements: function active_elements() {
          return this.$children.filter(function (t) {
            return !0 === t.status;
          });
        }
      },
      methods: {
        closeAll: function closeAll() {
          this.$children.forEach(function (t) {
            t.close();
          });
        },
        openAll: function openAll() {
          this.$children.forEach(function (t) {
            t.open();
          });
        }
      }
    };
  }, function (t, e, n) {
    "use strict";

    function s(t) {
      return t && t.__esModule ? t : {
        "default": t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = n(5),
        i = s(o),
        r = n(8),
        c = s(r),
        u = n(0),
        l = {};
    l.install = function (t, e) {
      var n = Object.assign(u.defaults, e);
      t.component(n.prefix + "-wrapper", i["default"]), t.component(n.prefix + "-group", c["default"]), t.mixin({
        created: function created() {
          this.$options.$vc = {
            settings: n
          };
        }
      }), t.directive(n.basename + "-content", {
        bind: function bind(t, e, n, s) {
          n.elm.classList.add(n.context.$options.$vc.settings.contentClassDefault);
        }
      }), t.directive(n.basename + "-toggle", {
        bind: function bind(t, e, n, s) {
          n.elm.classList.add(n.context.$options.$vc.settings.togglerClassDefault);
        },
        inserted: function inserted(t, e, n, s) {
          null != e.value && n.elm.addEventListener("click", function () {
            n.context.$refs[e.value].status = !n.context.$refs[e.value].status;
          }.bind(this));
        }
      });
    }, "undefined" != typeof window && window.Vue && window.Vue.use(l), e["default"] = l;
  }, function (t, e, n) {
    "use strict";

    function s(t) {
      n(6);
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var o = n(2),
        i = n.n(o);

    for (var r in o) {
      "default" !== r && function (t) {
        n.d(e, t, function () {
          return o[t];
        });
      }(r);
    }

    var c = n(7),
        u = n(1),
        l = s,
        a = u(i.a, c.a, !1, l, null, null);
    e["default"] = a.exports;
  }, function (t, e) {}, function (t, e, n) {
    "use strict";

    var s = function s() {
      var t = this,
          e = t.$createElement;
      return (t._self._c || e)("div", {
        "class": "vc-" + t.$options.$vc.settings.basename
      }, [t._t("default")], 2);
    },
        o = [],
        i = {
      render: s,
      staticRenderFns: o
    };

    e.a = i;
  }, function (t, e, n) {
    "use strict";

    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    var s = n(3),
        o = n.n(s);

    for (var i in s) {
      "default" !== i && function (t) {
        n.d(e, t, function () {
          return s[t];
        });
      }(i);
    }

    var r = n(9),
        c = n(1),
        u = c(o.a, r.a, !1, null, null, null);
    e["default"] = u.exports;
  }, function (t, e, n) {
    "use strict";

    var s = function s() {
      var t = this,
          e = t.$createElement;
      return (t._self._c || e)("div", {
        staticClass: "v-collapse-group"
      }, [t._t("default")], 2);
    },
        o = [],
        i = {
      render: s,
      staticRenderFns: o
    };

    e.a = i;
  }]);
});